
export default {
  data: () => ({ selectedTab: 'tab1' }),
    methods: {
      handleTabChange(tab) {
        this.selectedTab = tab;
      },
    },
  };